/* tslint:disable */
/* eslint-disable */
/**
 * Coproperty API
 * MRI coproperties (the risk entity of the MRI branch) — creation, structural attributes, buildings, and attachment to the risk.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CopropertyAddressCommand } from './CopropertyAddressCommand';
import {
    CopropertyAddressCommandFromJSON,
    CopropertyAddressCommandFromJSONTyped,
    CopropertyAddressCommandToJSON,
    CopropertyAddressCommandToJSONTyped,
} from './CopropertyAddressCommand';

/**
 * 
 * @export
 * @interface CreateCopropertyCommand
 */
export interface CreateCopropertyCommand {
    /**
     * 
     * @type {CopropertyAddressCommand}
     * @memberof CreateCopropertyCommand
     */
    address: CopropertyAddressCommand;
    /**
     * 
     * @type {string}
     * @memberof CreateCopropertyCommand
     */
    name?: string | null;
    /**
     * RNIC national registration number.
     * @type {string}
     * @memberof CreateCopropertyCommand
     */
    registrationNumber?: string | null;
}

/**
 * Check if a given object implements the CreateCopropertyCommand interface.
 */
export function instanceOfCreateCopropertyCommand(value: object): value is CreateCopropertyCommand {
    if (!('address' in value) || value['address'] === undefined) return false;
    return true;
}

export function CreateCopropertyCommandFromJSON(json: any): CreateCopropertyCommand {
    return CreateCopropertyCommandFromJSONTyped(json, false);
}

export function CreateCopropertyCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateCopropertyCommand {
    if (json == null) {
        return json;
    }
    return {
        
        'address': CopropertyAddressCommandFromJSON(json['address']),
        'name': json['name'] == null ? undefined : json['name'],
        'registrationNumber': json['registrationNumber'] == null ? undefined : json['registrationNumber'],
    };
}

export function CreateCopropertyCommandToJSON(json: any): CreateCopropertyCommand {
    return CreateCopropertyCommandToJSONTyped(json, false);
}

export function CreateCopropertyCommandToJSONTyped(value?: CreateCopropertyCommand | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'address': CopropertyAddressCommandToJSON(value['address']),
        'name': value['name'],
        'registrationNumber': value['registrationNumber'],
    };
}

